module.exports = __webpack_public_path__ + "img/red_ck.9a7e92af.svg";